import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-14 md:py-16">
        {/* Top: Brand + Description */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-12 gap-4">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
              <i className="ri-table-line text-background-50 text-lg"></i>
            </div>
            <span className="font-heading text-xl font-semibold text-background-50 tracking-tight">
              LitBuy <span className="text-primary-400">Spreadsheets</span>
            </span>
          </div>
          <p className="text-sm text-background-300 max-w-md leading-relaxed">
            Your trusted resource hub for LitBuy Spreadsheet guides, tutorials, and shopping deal tracking templates.
          </p>
        </div>

        {/* Middle: 4-column nav */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-8 mb-12">
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Shop</h4>
            <div className="flex flex-col gap-2.5">
              <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">All Categories</a>
              <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">Shoes</a>
              <a href="https://kaspreadsheet.com/category-913-T-Shirts.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">T-Shirts</a>
              <a href="https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">Hoodies</a>
            </div>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Resources</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/blog/litbuy-spreadsheet-complete-guide" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">Complete Guide</Link>
              <Link to="/blog/best-litbuy-spreadsheet-templates" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">Templates</Link>
              <Link to="/blog/how-to-use-litbuy-spreadsheet" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">Tutorials</Link>
              <Link to="/blog/litbuy-spreadsheet-vs-google-sheets" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">Comparisons</Link>
            </div>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Company</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">About Us</Link>
              <Link to="/#faq" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">FAQ</Link>
              <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">KASpreadsheet</a>
              <Link to="/blog/litbuy-spreadsheet-complete-guide" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">Blog</Link>
            </div>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Legal</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">Privacy Policy</Link>
              <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">Terms of Use</Link>
              <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">Disclaimer</Link>
              <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">Safety Statement</Link>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-background-800/40 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex flex-col sm:flex-row items-center gap-4">
            <p className="text-xs text-background-500">&copy; {new Date().getFullYear()} LitBuy Spreadsheets. All rights reserved.</p>
            <div className="flex items-center gap-4">
              <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer">kaspreadsheet.com</a>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800/50 text-background-400 hover:text-primary-400 hover:bg-primary-500/20 transition-colors cursor-pointer">
              <i className="ri-shopping-bag-line text-sm"></i>
            </a>
            <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800/50 text-background-400 hover:text-primary-400 hover:bg-primary-500/20 transition-colors cursor-pointer">
              <i className="ri-twitter-x-line text-sm"></i>
            </a>
            <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800/50 text-background-400 hover:text-primary-400 hover:bg-primary-500/20 transition-colors cursor-pointer">
              <i className="ri-instagram-line text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}